/**
 * @fileoverview gRPC-Web generated client stub for witbooking.backoffice.mealplan.v1
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!



const grpc = {};
grpc.web = require('grpc-web');


var validate_validate_pb = require('../../../../validate/validate_pb.js')
const proto = {};
proto.witbooking = {};
proto.witbooking.backoffice = {};
proto.witbooking.backoffice.mealplan = {};
proto.witbooking.backoffice.mealplan.v1 = require('./mealplan_api_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.witbooking.backoffice.mealplan.v1.MealPlanAPIClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.witbooking.backoffice.mealplan.v1.MealPlanAPIPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.mealplan.v1.GetMealPlanRequest,
 *   !proto.witbooking.backoffice.mealplan.v1.GetMealPlanResponse>}
 */
const methodDescriptor_MealPlanAPI_GetMealPlan = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.mealplan.v1.MealPlanAPI/GetMealPlan',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.mealplan.v1.GetMealPlanRequest,
  proto.witbooking.backoffice.mealplan.v1.GetMealPlanResponse,
  /**
   * @param {!proto.witbooking.backoffice.mealplan.v1.GetMealPlanRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.mealplan.v1.GetMealPlanResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.mealplan.v1.GetMealPlanRequest,
 *   !proto.witbooking.backoffice.mealplan.v1.GetMealPlanResponse>}
 */
const methodInfo_MealPlanAPI_GetMealPlan = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.mealplan.v1.GetMealPlanResponse,
  /**
   * @param {!proto.witbooking.backoffice.mealplan.v1.GetMealPlanRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.mealplan.v1.GetMealPlanResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.mealplan.v1.GetMealPlanRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.mealplan.v1.GetMealPlanResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.mealplan.v1.GetMealPlanResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.mealplan.v1.MealPlanAPIClient.prototype.getMealPlan =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.mealplan.v1.MealPlanAPI/GetMealPlan',
      request,
      metadata || {},
      methodDescriptor_MealPlanAPI_GetMealPlan,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.mealplan.v1.GetMealPlanRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.mealplan.v1.GetMealPlanResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.mealplan.v1.MealPlanAPIPromiseClient.prototype.getMealPlan =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.mealplan.v1.MealPlanAPI/GetMealPlan',
      request,
      metadata || {},
      methodDescriptor_MealPlanAPI_GetMealPlan);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.mealplan.v1.GetAllMealPlansRequest,
 *   !proto.witbooking.backoffice.mealplan.v1.GetAllMealPlansResponse>}
 */
const methodDescriptor_MealPlanAPI_GetAllMealPlans = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.mealplan.v1.MealPlanAPI/GetAllMealPlans',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.mealplan.v1.GetAllMealPlansRequest,
  proto.witbooking.backoffice.mealplan.v1.GetAllMealPlansResponse,
  /**
   * @param {!proto.witbooking.backoffice.mealplan.v1.GetAllMealPlansRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.mealplan.v1.GetAllMealPlansResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.mealplan.v1.GetAllMealPlansRequest,
 *   !proto.witbooking.backoffice.mealplan.v1.GetAllMealPlansResponse>}
 */
const methodInfo_MealPlanAPI_GetAllMealPlans = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.mealplan.v1.GetAllMealPlansResponse,
  /**
   * @param {!proto.witbooking.backoffice.mealplan.v1.GetAllMealPlansRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.mealplan.v1.GetAllMealPlansResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.mealplan.v1.GetAllMealPlansRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.mealplan.v1.GetAllMealPlansResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.mealplan.v1.GetAllMealPlansResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.mealplan.v1.MealPlanAPIClient.prototype.getAllMealPlans =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.mealplan.v1.MealPlanAPI/GetAllMealPlans',
      request,
      metadata || {},
      methodDescriptor_MealPlanAPI_GetAllMealPlans,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.mealplan.v1.GetAllMealPlansRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.mealplan.v1.GetAllMealPlansResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.mealplan.v1.MealPlanAPIPromiseClient.prototype.getAllMealPlans =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.mealplan.v1.MealPlanAPI/GetAllMealPlans',
      request,
      metadata || {},
      methodDescriptor_MealPlanAPI_GetAllMealPlans);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.mealplan.v1.CreateMealPlanRequest,
 *   !proto.witbooking.backoffice.mealplan.v1.CreateMealPlanResponse>}
 */
const methodDescriptor_MealPlanAPI_CreateMealPlan = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.mealplan.v1.MealPlanAPI/CreateMealPlan',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.mealplan.v1.CreateMealPlanRequest,
  proto.witbooking.backoffice.mealplan.v1.CreateMealPlanResponse,
  /**
   * @param {!proto.witbooking.backoffice.mealplan.v1.CreateMealPlanRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.mealplan.v1.CreateMealPlanResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.mealplan.v1.CreateMealPlanRequest,
 *   !proto.witbooking.backoffice.mealplan.v1.CreateMealPlanResponse>}
 */
const methodInfo_MealPlanAPI_CreateMealPlan = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.mealplan.v1.CreateMealPlanResponse,
  /**
   * @param {!proto.witbooking.backoffice.mealplan.v1.CreateMealPlanRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.mealplan.v1.CreateMealPlanResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.mealplan.v1.CreateMealPlanRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.mealplan.v1.CreateMealPlanResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.mealplan.v1.CreateMealPlanResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.mealplan.v1.MealPlanAPIClient.prototype.createMealPlan =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.mealplan.v1.MealPlanAPI/CreateMealPlan',
      request,
      metadata || {},
      methodDescriptor_MealPlanAPI_CreateMealPlan,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.mealplan.v1.CreateMealPlanRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.mealplan.v1.CreateMealPlanResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.mealplan.v1.MealPlanAPIPromiseClient.prototype.createMealPlan =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.mealplan.v1.MealPlanAPI/CreateMealPlan',
      request,
      metadata || {},
      methodDescriptor_MealPlanAPI_CreateMealPlan);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.mealplan.v1.UpdateMealPlanRequest,
 *   !proto.witbooking.backoffice.mealplan.v1.UpdateMealPlanResponse>}
 */
const methodDescriptor_MealPlanAPI_UpdateMealPlan = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.mealplan.v1.MealPlanAPI/UpdateMealPlan',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.mealplan.v1.UpdateMealPlanRequest,
  proto.witbooking.backoffice.mealplan.v1.UpdateMealPlanResponse,
  /**
   * @param {!proto.witbooking.backoffice.mealplan.v1.UpdateMealPlanRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.mealplan.v1.UpdateMealPlanResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.mealplan.v1.UpdateMealPlanRequest,
 *   !proto.witbooking.backoffice.mealplan.v1.UpdateMealPlanResponse>}
 */
const methodInfo_MealPlanAPI_UpdateMealPlan = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.mealplan.v1.UpdateMealPlanResponse,
  /**
   * @param {!proto.witbooking.backoffice.mealplan.v1.UpdateMealPlanRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.mealplan.v1.UpdateMealPlanResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.mealplan.v1.UpdateMealPlanRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.mealplan.v1.UpdateMealPlanResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.mealplan.v1.UpdateMealPlanResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.mealplan.v1.MealPlanAPIClient.prototype.updateMealPlan =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.mealplan.v1.MealPlanAPI/UpdateMealPlan',
      request,
      metadata || {},
      methodDescriptor_MealPlanAPI_UpdateMealPlan,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.mealplan.v1.UpdateMealPlanRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.mealplan.v1.UpdateMealPlanResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.mealplan.v1.MealPlanAPIPromiseClient.prototype.updateMealPlan =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.mealplan.v1.MealPlanAPI/UpdateMealPlan',
      request,
      metadata || {},
      methodDescriptor_MealPlanAPI_UpdateMealPlan);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanRequest,
 *   !proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanResponse>}
 */
const methodDescriptor_MealPlanAPI_DeleteMealPlan = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.mealplan.v1.MealPlanAPI/DeleteMealPlan',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanRequest,
  proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanResponse,
  /**
   * @param {!proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanRequest,
 *   !proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanResponse>}
 */
const methodInfo_MealPlanAPI_DeleteMealPlan = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanResponse,
  /**
   * @param {!proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.mealplan.v1.MealPlanAPIClient.prototype.deleteMealPlan =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.mealplan.v1.MealPlanAPI/DeleteMealPlan',
      request,
      metadata || {},
      methodDescriptor_MealPlanAPI_DeleteMealPlan,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.mealplan.v1.MealPlanAPIPromiseClient.prototype.deleteMealPlan =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.mealplan.v1.MealPlanAPI/DeleteMealPlan',
      request,
      metadata || {},
      methodDescriptor_MealPlanAPI_DeleteMealPlan);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.mealplan.v1.ReorderMealPlanRequest,
 *   !proto.witbooking.backoffice.mealplan.v1.ReorderMealPlanResponse>}
 */
const methodDescriptor_MealPlanAPI_ReorderMealPlan = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.mealplan.v1.MealPlanAPI/ReorderMealPlan',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.mealplan.v1.ReorderMealPlanRequest,
  proto.witbooking.backoffice.mealplan.v1.ReorderMealPlanResponse,
  /**
   * @param {!proto.witbooking.backoffice.mealplan.v1.ReorderMealPlanRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.mealplan.v1.ReorderMealPlanResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.mealplan.v1.ReorderMealPlanRequest,
 *   !proto.witbooking.backoffice.mealplan.v1.ReorderMealPlanResponse>}
 */
const methodInfo_MealPlanAPI_ReorderMealPlan = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.mealplan.v1.ReorderMealPlanResponse,
  /**
   * @param {!proto.witbooking.backoffice.mealplan.v1.ReorderMealPlanRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.mealplan.v1.ReorderMealPlanResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.mealplan.v1.ReorderMealPlanRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.mealplan.v1.ReorderMealPlanResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.mealplan.v1.ReorderMealPlanResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.mealplan.v1.MealPlanAPIClient.prototype.reorderMealPlan =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.mealplan.v1.MealPlanAPI/ReorderMealPlan',
      request,
      metadata || {},
      methodDescriptor_MealPlanAPI_ReorderMealPlan,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.mealplan.v1.ReorderMealPlanRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.mealplan.v1.ReorderMealPlanResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.mealplan.v1.MealPlanAPIPromiseClient.prototype.reorderMealPlan =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.mealplan.v1.MealPlanAPI/ReorderMealPlan',
      request,
      metadata || {},
      methodDescriptor_MealPlanAPI_ReorderMealPlan);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanForCloningRequest,
 *   !proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanForCloningResponse>}
 */
const methodDescriptor_MealPlanAPI_DeleteMealPlanForCloning = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.mealplan.v1.MealPlanAPI/DeleteMealPlanForCloning',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanForCloningRequest,
  proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanForCloningResponse,
  /**
   * @param {!proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanForCloningRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanForCloningResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanForCloningRequest,
 *   !proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanForCloningResponse>}
 */
const methodInfo_MealPlanAPI_DeleteMealPlanForCloning = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanForCloningResponse,
  /**
   * @param {!proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanForCloningRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanForCloningResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanForCloningRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanForCloningResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanForCloningResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.mealplan.v1.MealPlanAPIClient.prototype.deleteMealPlanForCloning =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.mealplan.v1.MealPlanAPI/DeleteMealPlanForCloning',
      request,
      metadata || {},
      methodDescriptor_MealPlanAPI_DeleteMealPlanForCloning,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanForCloningRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.mealplan.v1.DeleteMealPlanForCloningResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.mealplan.v1.MealPlanAPIPromiseClient.prototype.deleteMealPlanForCloning =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.mealplan.v1.MealPlanAPI/DeleteMealPlanForCloning',
      request,
      metadata || {},
      methodDescriptor_MealPlanAPI_DeleteMealPlanForCloning);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.mealplan.v1.CreateMealPlanForCloningRequest,
 *   !proto.witbooking.backoffice.mealplan.v1.CreateMealPlanForCloningResponse>}
 */
const methodDescriptor_MealPlanAPI_CreateMealPlanForCloning = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.mealplan.v1.MealPlanAPI/CreateMealPlanForCloning',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.mealplan.v1.CreateMealPlanForCloningRequest,
  proto.witbooking.backoffice.mealplan.v1.CreateMealPlanForCloningResponse,
  /**
   * @param {!proto.witbooking.backoffice.mealplan.v1.CreateMealPlanForCloningRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.mealplan.v1.CreateMealPlanForCloningResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.mealplan.v1.CreateMealPlanForCloningRequest,
 *   !proto.witbooking.backoffice.mealplan.v1.CreateMealPlanForCloningResponse>}
 */
const methodInfo_MealPlanAPI_CreateMealPlanForCloning = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.mealplan.v1.CreateMealPlanForCloningResponse,
  /**
   * @param {!proto.witbooking.backoffice.mealplan.v1.CreateMealPlanForCloningRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.mealplan.v1.CreateMealPlanForCloningResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.mealplan.v1.CreateMealPlanForCloningRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.mealplan.v1.CreateMealPlanForCloningResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.mealplan.v1.CreateMealPlanForCloningResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.mealplan.v1.MealPlanAPIClient.prototype.createMealPlanForCloning =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.mealplan.v1.MealPlanAPI/CreateMealPlanForCloning',
      request,
      metadata || {},
      methodDescriptor_MealPlanAPI_CreateMealPlanForCloning,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.mealplan.v1.CreateMealPlanForCloningRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.mealplan.v1.CreateMealPlanForCloningResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.mealplan.v1.MealPlanAPIPromiseClient.prototype.createMealPlanForCloning =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.mealplan.v1.MealPlanAPI/CreateMealPlanForCloning',
      request,
      metadata || {},
      methodDescriptor_MealPlanAPI_CreateMealPlanForCloning);
};


module.exports = proto.witbooking.backoffice.mealplan.v1;

